
<template>
  <a-layout style="background-color: #F6F9F9;">
    <global-header />
    <div class="basic-height">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>

    <!-- <a-layout-footer> -->
    <!-- <global-footer /> -->
    <!-- </a-layout-footer> -->
  </a-layout>
</template>
<script>
import GlobalHeader from '@/components/GlobalHeader/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter/GlobalFooter'

import RouteView from './RouteView'

// import hm from '@/utils/hm.js'
export default {
  name: 'BasicLayout',
  components: {
    RouteView,
    GlobalHeader,
    GlobalFooter
  },
  mounted () {
    // 百度商桥
    // hm.hm()
  }
}
</script>
<style lang="less" scoped>
@import '../styles/var.less';
.basic-height{
  padding-top: 40px;
  min-height: 100vh;
}
</style>
